package nacholab.supplies.ui.theme

object SuppliesTheme {

    private val lightColors = ColorScheme(
        primary = MainColors.WHITE,
        primaryVariant = MainColors.LIGHT_CYAN,
        secondary = MainColors.YELLOW,
        secondaryVariant = MainColors.GREEN,
        background = MainColors.LLA_BLUE,
        utilityBlack = MainColors.BLACK,
        utilityField = MainColors.DARK_CYAN,
        utilityError = MainColors.RED,
        utilityTableBorder = MainColors.SHEET_GRAY,
        utilityBackdrop = MainColors.BLACK_TRANSPARENT_128,
    )

    val colors = lightColors
}